var render = function render(){
  var _vm$posts, _vm$posts2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('UiGridCard', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', {
          staticClass: "flex items-start"
        }, [_c('h2', {
          staticClass: "font-bold"
        }, [_vm._v("В центре вашего внимания")]), _vm._v(" "), _vm.$auth.loggedIn ? _c('button', {
          staticClass: "flex items-center ml-auto text-comment text-gray-1 bg-primary-bg px-3 py-1.75 rounded-md hover:text-accent",
          on: {
            "click": _vm.openSettingsModal
          }
        }, [_c('CoreIcon', {
          staticClass: "w-4 h-4 fill-current mr-2.5 transition",
          attrs: {
            "name": "settings"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "transition"
        }, [_vm._v("Настроить")])], 1) : _vm._e()])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "-ml-base-card-left-m -mr-base-card-right-m tab:-ml-base-card-left-t tab:-mr-base-card-right-t desktop:-ml-base-card-left desktop:-mr-base-card-right border-b border-primary-bg"
  }, [_c('ul', {
    staticClass: "relative flex items-start w-full text-gray-1 text-comment pl-base-card-left-m pr-base-card-right-m tab:pl-base-card-left-t tab:pr-base-card-right-t desktop:pl-base-card-left desktop:pr-base-card-right"
  }, [_vm.$auth.loggedIn ? _c('li', {
    staticClass: "flex items-center mr-5"
  }, [_c('button', {
    staticClass: "flex items-center py-4 px-2 transition",
    class: {
      'border-b-2 border-accent  font-medium': _vm.type === 'video'
    },
    on: {
      "click": function ($event) {
        _vm.type = 'video';
      }
    }
  }, [_c('CoreIcon', {
    staticClass: "hidden tab:inline-block w-4 h-4 mr-1.5 fill-current",
    attrs: {
      "name": "play-alt"
    }
  }), _vm._v("\n          Видео\n        ")], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "flex items-center mr-5"
  }, [_c('button', {
    staticClass: "flex items-center py-4 px-2 transition",
    class: {
      'border-b-2 border-accent  font-medium': _vm.type === 'article'
    },
    on: {
      "click": function ($event) {
        _vm.type = 'article';
      }
    }
  }, [_c('CoreIcon', {
    staticClass: "hidden tab:inline-block w-4 h-4 mr-1.5 fill-current",
    attrs: {
      "name": "text"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Статьи")])], 1)])])]), _vm._v(" "), _c('div', {
    ref: "navWrap",
    staticClass: "flex items-start w-full mt-2 overflow-hidden"
  }, [_vm.$auth.loggedIn ? _c('ul', {
    ref: "navList",
    staticClass: "relative flex items-center text-comment sr-only"
  }, [_c('li', {
    staticClass: "flex m-1.25"
  }, [_c('button', {
    staticClass: "leading-none flex hover:text-accent transition py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
    class: {
      'font-medium': !_vm.currentItem
    },
    on: {
      "click": function ($event) {
        return _vm.setCurrentItem(null);
      }
    }
  }, [_vm._v("\n          Все\n        ")])]), _vm._v(" "), _vm._l(_vm.userStreams, function (str) {
    var _vm$currentItem, _vm$currentItem2;
    return _c('li', {
      key: str.stream._id,
      staticClass: "flex-shrink-0 m-1.25"
    }, [_c('button', {
      staticClass: "leading-none flex hover:text-accent transition whitespace-nowrap py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
      class: {
        'font-medium': ((_vm$currentItem = _vm.currentItem) === null || _vm$currentItem === void 0 ? void 0 : _vm$currentItem.entity) === 'stream' && ((_vm$currentItem2 = _vm.currentItem) === null || _vm$currentItem2 === void 0 ? void 0 : _vm$currentItem2.id) === str.stream.url
      },
      on: {
        "click": function ($event) {
          return _vm.setCurrentItem({
            entity: 'stream',
            id: str.stream.url
          });
        }
      }
    }, [_vm._v("\n          " + _vm._s(str.stream.title) + "\n        ")])]);
  }), _vm._v(" "), _vm._l(_vm.userCompanys, function (company) {
    var _vm$currentItem3, _vm$currentItem4;
    return _c('li', {
      key: company._id,
      staticClass: "flex-shrink-0 m-1.25"
    }, [_c('button', {
      staticClass: "leading-none flex hover:text-accent transition whitespace-nowrap py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
      class: {
        'font-medium': ((_vm$currentItem3 = _vm.currentItem) === null || _vm$currentItem3 === void 0 ? void 0 : _vm$currentItem3.entity) === 'company' && ((_vm$currentItem4 = _vm.currentItem) === null || _vm$currentItem4 === void 0 ? void 0 : _vm$currentItem4.id) === company._id
      },
      on: {
        "click": function ($event) {
          return _vm.setCurrentItem({
            entity: 'company',
            id: company._id
          });
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$author.authorName(company)) + "\n        ")])]);
  }), _vm._v(" "), _vm._l(_vm.userAuthors, function (author) {
    var _vm$currentItem5, _vm$currentItem6;
    return _c('li', {
      key: author._id,
      staticClass: "flex-shrink-0 m-1.25"
    }, [_c('button', {
      staticClass: "leading-none flex hover:text-accent transition whitespace-nowrap py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
      class: {
        'font-medium': ((_vm$currentItem5 = _vm.currentItem) === null || _vm$currentItem5 === void 0 ? void 0 : _vm$currentItem5.entity) === 'author' && ((_vm$currentItem6 = _vm.currentItem) === null || _vm$currentItem6 === void 0 ? void 0 : _vm$currentItem6.id) === author._id
      },
      on: {
        "click": function ($event) {
          return _vm.setCurrentItem({
            entity: 'author',
            id: author._id
          });
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$author.authorName(author)) + "\n        ")])]);
  })], 2) : _vm._e(), _vm._v(" "), _vm.$auth.loggedIn ? _c('ul', {
    staticClass: "relative flex items-center text-comment",
    class: {
      'flex-wrap': _vm.isVisibleAllCollections,
      'overflow-x-hidden shadow-right-block ': !_vm.isVisibleAllCollections && !_vm.isNavFits
    }
  }, [_c('li', {
    staticClass: "flex m-1.25"
  }, [_c('button', {
    staticClass: "leading-none flex hover:text-accent transition py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
    class: {
      'font-medium': !_vm.currentItem
    },
    on: {
      "click": function ($event) {
        return _vm.setCurrentItem(null);
      }
    }
  }, [_vm._v("\n          Все\n        ")])]), _vm._v(" "), _vm._l(_vm.userStreams, function (str) {
    var _vm$currentItem7, _vm$currentItem8;
    return _c('li', {
      key: str.stream._id,
      staticClass: "flex-shrink-0 m-1.25"
    }, [_c('button', {
      staticClass: "leading-none flex hover:text-accent transition whitespace-nowrap py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
      class: {
        'font-medium': ((_vm$currentItem7 = _vm.currentItem) === null || _vm$currentItem7 === void 0 ? void 0 : _vm$currentItem7.entity) === 'stream' && ((_vm$currentItem8 = _vm.currentItem) === null || _vm$currentItem8 === void 0 ? void 0 : _vm$currentItem8.id) === str.stream.url
      },
      on: {
        "click": function ($event) {
          return _vm.setCurrentItem({
            entity: 'stream',
            id: str.stream.url
          });
        }
      }
    }, [_vm._v("\n          " + _vm._s(str.stream.title) + "\n        ")])]);
  }), _vm._v(" "), _vm._l(_vm.userCompanys, function (company) {
    var _vm$currentItem9, _vm$currentItem10;
    return _c('li', {
      key: company._id,
      staticClass: "flex-shrink-0 m-1.25"
    }, [_c('button', {
      staticClass: "leading-none flex hover:text-accent transition whitespace-nowrap py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
      class: {
        'font-medium': ((_vm$currentItem9 = _vm.currentItem) === null || _vm$currentItem9 === void 0 ? void 0 : _vm$currentItem9.entity) === 'company' && ((_vm$currentItem10 = _vm.currentItem) === null || _vm$currentItem10 === void 0 ? void 0 : _vm$currentItem10.id) === company._id
      },
      on: {
        "click": function ($event) {
          return _vm.setCurrentItem({
            entity: 'company',
            id: company._id
          });
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$author.authorName(company)) + "\n        ")])]);
  }), _vm._v(" "), _vm._l(_vm.userAuthors, function (author) {
    var _vm$currentItem11, _vm$currentItem12;
    return _c('li', {
      key: author._id,
      staticClass: "flex-shrink-0 m-1.25"
    }, [_c('button', {
      staticClass: "leading-none flex hover:text-accent transition whitespace-nowrap py-1.5 px-3 bg-primary-bg rounded-md text-gray-1",
      class: {
        'font-medium': ((_vm$currentItem11 = _vm.currentItem) === null || _vm$currentItem11 === void 0 ? void 0 : _vm$currentItem11.entity) === 'author' && ((_vm$currentItem12 = _vm.currentItem) === null || _vm$currentItem12 === void 0 ? void 0 : _vm$currentItem12.id) === author._id
      },
      on: {
        "click": function ($event) {
          return _vm.setCurrentItem({
            entity: 'author',
            id: author._id
          });
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$author.authorName(author)) + "\n        ")])]);
  })], 2) : _vm._e(), _vm._v(" "), !_vm.isNavFits ? _c('button', {
    staticClass: "flex items-center justify-center bg-primary-bg text-gray-1 hover:text-accent transition p-1.25 rounded-md ml-2.5 my-1.25",
    on: {
      "click": function ($event) {
        _vm.isVisibleAllCollections = !_vm.isVisibleAllCollections;
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Весь список")]), _vm._v(" "), _c('CoreIcon', {
    staticClass: "w-4 h-4 fill-current transition-transform",
    class: {
      'transform rotate-180': _vm.isVisibleAllCollections
    },
    attrs: {
      "name": "arrow-down"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm.isLoad ? _c('div', {
    staticClass: "h-80 flex items-center justify-center"
  }, [_c('CoreIcon', {
    staticClass: "w-12 h-12 text-accent fill-current",
    attrs: {
      "name": "preload"
    }
  })], 1) : (_vm$posts = _vm.posts) !== null && _vm$posts !== void 0 && _vm$posts.length ? _c('ul', {
    staticClass: "grid grid-cols-1 phone-l:grid-cols-2 tab:grid-cols-3 gap-2.5 mt-5"
  }, _vm._l(_vm.posts, function (post) {
    return _c('li', {
      key: post._id
    }, [_vm.type === 'video' ? _c('MegasredaContentVideoGridCard', {
      attrs: {
        "post": post
      }
    }) : _vm._e(), _vm._v(" "), _vm.type === 'article' ? _c('MegasredaContentPostGridCard', {
      attrs: {
        "post": post
      }
    }) : _vm._e()], 1);
  }), 0) : !_vm.isLoad ? _c('UiGridCard', {
    staticClass: "flex items-center justify-center pb-8 pt-5 px-4 tab:px-7.5"
  }, [_c('div', [_c('p', {
    staticClass: "text-gray-1 text-center font-bold"
  }, [_vm._v("\n        Ваш список наблюдения пуст\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2.5 text-center text-comment text-gray-1"
  }, [_vm._v("\n        Начните создавать свой список"), _c('br'), _vm._v("наблюдения, нажав кнопку ниже\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$auth.loggedIn ? _c('button', {
    staticClass: "mt-5 flex items-center px-2 phone-l:px-8 py-2 rounded-lg text-comment text-primary-white bg-accent border border-accent hover:bg-accent-light hover:border-accent-light transition disabled:cursor-not-allowed disabled:bg-accent-light",
    on: {
      "click": _vm.openSettingsModal
    }
  }, [_c('CoreIcon', {
    staticClass: "w-4 h-4 fill-current mr-2.5 transition",
    attrs: {
      "name": "settings"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "transition"
  }, [_vm._v("Настроить")])], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), ((_vm$posts2 = _vm.posts) === null || _vm$posts2 === void 0 ? void 0 : _vm$posts2.length) < _vm.postsCount ? _c('button', {
    staticClass: "flex items-center justify-center w-full mt-4 px-2 phone-l:px-8 py-1.5 rounded-lg text-comment text-gray-2 border border-gray-2 hover:text-gray-3 hover:border-gray-3 transition font-medium",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("\n    Посмотреть ещё\n  ")]) : _vm._e(), _vm._v(" "), _c('BaseCurrentSettingsFull', {
    ref: "settingsModal",
    on: {
      "update": _vm.updateSettings
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }